import { render, staticRenderFns } from "./NeurologicalAssessmentPanel.vue?vue&type=template&id=1a027d9f&scoped=true&"
import script from "./NeurologicalAssessmentPanel.vue?vue&type=script&lang=js&"
export * from "./NeurologicalAssessmentPanel.vue?vue&type=script&lang=js&"
import style0 from "./NeurologicalAssessmentPanel.vue?vue&type=style&index=0&id=1a027d9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a027d9f",
  null
  
)

export default component.exports